<template>
  <div class="grid-wrap">
    <h2
      class="grid--sm-100 grid--lg-50 ucase grey"
      v-html="content.header"></h2>
    <div class="grid--sm-100 grid--lg-50">
      <p
        v-if="listHeader"
        class="list-header bold">
        {{ listHeader }}
      </p>
      <ul
        v-if="content.list"
        class="list">
        <li
          v-for="(item, listKey) in content.list"
          :key="listKey"
          v-html="item.list_item"></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderList',
  props: {
    content: {
      type: Object,
      default: null
    },
    listHeader: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.list-header {
  margin-bottom: $gutter--base;
}
.list {
  @include list;
}
</style>
